const handleFormSuccess = (setState, initialState) => (info = '') => {
  setState({
    ...initialState,
    info,
  });
};

export default handleFormSuccess;
